import { IconToggle } from '@/components/SideMenu/styles';
import { useBranch } from '@/hooks/useBranch';
import { useSideNav } from '@/hooks/useSideNav';
import {
  As,
  Avatar,
  Divider,
  Flex,
  HStack,
  IconButton,
  Image,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Spacer,
  Text,
} from '@chakra-ui/react';
import { FiLogOut } from 'react-icons/fi';

import expertoLogo from '../../../assets/expertosbranco.png';

interface IHeaderInfoUser {
  Link: As | undefined;
  user: string | null;
}
export default function HeaderInfoUser({

  Link,
  user,
}: IHeaderInfoUser) {

  const { open, buttonProps } = useSideNav();

  const userName = user?.split("@")[0] || "";
  const userLogo = user?.substring(0, 2).toUpperCase();
  const { filial } = useBranch();

  return (
    <>
      <Flex
        borderBottom={"1px solid rgba(255,255,255,0.2)"}
        background={"#0f4f6d"}
        height={"42px"}
        alignItems={"center"}
        p={3}
      >
        <Menu>
          <IconToggle $open={open} {...buttonProps}>
            <Image
              src={expertoLogo}
              alt="Expertos Logo"
              height={"300px"}
              objectFit="contain"
            />
          </IconToggle>
        </Menu>
        <Spacer />
        <HStack spacing={3}>

          <Menu>
            <MenuButton
              as={IconButton}
              size={"sm"}
              bg={"blue.500"}
              borderRadius={"full"}
              aria-label="user-menu"
            >
              <Text color={"white"}>{userLogo}</Text>
            </MenuButton>

            <MenuList boxShadow={'2px 3px 10px rgba(244, 244, 244, 0.33)'} zIndex={1000} bgColor="#0f4f6d" borderColor="#0f4f6d" minWidth="260px">
              <Flex p={3} direction="column">
                <Flex align="center" mb={2}>
                  <Avatar
                    size="md"
                    bg="blue.500"
                    mr={3}
                    fontSize="xl"
                  />
                  <Flex direction="column">
                    <Text fontWeight="sm" color="gray.400" fontSize={'xx-small'} textTransform={'uppercase'}>{filial?.nomefantasia}</Text>
                    <Text fontWeight="bold" color="white">{userName}</Text>
                    <Text fontSize="sm" color="gray.400">{user}</Text>
                  </Flex>
                </Flex>
              </Flex>

              <Divider borderColor="#444" />
              <MenuItem icon={<FiLogOut />} as={Link} to="/logout">
                Sair
              </MenuItem>
            </MenuList>
          </Menu>
        </HStack>
      </Flex>
    </>
  );
}
